
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { SmartText } from "_components";

@Component({
  name: "NextEventHero",
  components: { SmartText },
})
export default class NextEventHero extends Vue {
  @Prop({ type: String }) title: string;

  @Ref() wrapper: HTMLElement;
  @Ref() titleEl: SmartText;
  @Ref() pseudoTitleEl: SmartText;

  rootClass = "p-event-takeover-hero";
}
